import React, { FC } from 'react'
import times from 'lodash/times'
import { Box } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'

interface IDedicatedLanesRowLoadingStateProps {
  height: number
  rows: number
}

export const DedicatedLanesRowLoadingState: FC<IDedicatedLanesRowLoadingStateProps> = ({
  height,
  rows,
}) => (
  <div>
    {times(rows).map(item => (
      <Box key={item} pb={2}>
        <Skeleton variant='rectangular' height={`${height}px`} />
      </Box>
    ))}
  </div>
)
